import { FC, useState } from 'react';
import { useTrans } from 'base/utils/i18n';
import { Button, ButtonProps } from '@base/lib/Button';
import { IVariant } from 'base/interfaces/product';
import { NotifyForm } from 'mod/product/ProdSoldOut/NotifyForm';
import { NotifyPopup } from 'mod/product/ProdSoldOut/NotifyPopup';

type IProps = {
    shownVariant: IVariant;
    className?: string;
    btnProps?: ButtonProps;
    popupProps: {
        className?: string;
        btnProps?: ButtonProps;
    };
}

export const ProdSoldOut: FC<IProps> = props => {
    const {
        shownVariant,
        className,
        btnProps,
        popupProps,
    } = props;

    const { expectedArrivalTime } = shownVariant;

    const [visible, setVisible] = useState<boolean>(false);
    const onClose = () => setVisible(false);
    const { t } = useTrans();

    return (
        <>
            <div className={className}>
                <div className={'g-tip'}>
                    <strong className={'g-sold-out'}>{t('web_product_sold_out')}.</strong>
                    {!!expectedArrivalTime && (
                        <span className={'g-time'}>
                            {' '}{expectedArrivalTime}
                        </span>
                    )}
                </div>

                <Button
                    className={'g-btn'}
                    onClick={() => setVisible(true)}
                    {...btnProps}
                >
                    {t('web_shop_product_notify_me_when_available')}
                </Button>
            </div>

            <NotifyPopup
                className={popupProps.className}
                visible={visible}
                onClose={onClose}
                title={t('web_shop_product_notify_me_when_available')}
                width={370}
            >
                <NotifyForm
                    shownVariant={shownVariant}
                    onClose={onClose}
                    btnProps={popupProps.btnProps}
                />
            </NotifyPopup>
        </>
    )
};
